import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { API_URL } from "../constants/constants";
import { useAuth } from "./AuthContext";

const useFetch = ({
  method = "get",
  url,
  data,
  headers = null,
  pagination = null,
  trigger = false,
  noHeader = false,
  argFunc = null,
  caller = null,
  params = null,
  errMessage = null,
  setter = null,
}) => {
  const [refetchStatus, setRefetchStatus] = useState(trigger);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [innerTrigger, setInnerTrigger] = useState(0);
  const controllerRef = useRef(new AbortController());
  const { token } = useAuth();
  const apiCall = async () => {
    try {
      const result = await axios.request({
        params: params,
        method: method,
        url: !!pagination
          ? `${API_URL}/${url}/?page=${pagination.current}&pageSize=${pagination.pageSize}`
          : `${API_URL}/${url}/`,
        data: data,
        headers: !noHeader
          ? {
              Authorization: `JWT ${token}`,
            }
          : {},

        signal: controllerRef.current.signal,
      });
      if (setter !== null) setter(result.data);
      if (caller !== null) caller.reFetch();
      if (argFunc !== null) argFunc(result.data);
      setRefetchStatus(false);
      setResponse(result.data);
    } catch (error) {
      setError(error);
      // errMessage(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (typeof trigger === "undefined" && !innerTrigger) return;
    // if (trigger) apiCall();
    if (refetchStatus) {
      setLoading(true);
      apiCall();
    }
  }, [innerTrigger]);

  const cancelRequest = () => {
    controllerRef.current.abort();
  };
  const reFetch = (type) => {
    // apiCall(nData, params);
    setInnerTrigger(+new Date());
    setRefetchStatus(true);
    // if (type !== "post") setPostReq(true);
  };

  return { response, error, loading, cancelRequest, reFetch };
};

export default useFetch;
